import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

// import custom theme styles
require('@/assets/scss/custom-theme.scss')
require('@/assets/scss/custom-theme-dark.scss')
require('@/assets/scss/custom-client-theme.scss')

Vue.config.productionTip = false
Vue.config.devtools = true

store.dispatch('auth/updateDataLocalStorage')

// Cryptojs
import VueCryptojs from 'vue-cryptojs';
Vue.use(VueCryptojs);

import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
flatpickr.localize(Portuguese); // default locale is now Russian
flatpickr.setDefaults(
  {
    // default options here
    dateFormat: 'd-m-Y',

  });

import VueHotkey from 'v-hotkey';
Vue.use(VueHotkey);

import VueLuxon from "vue-luxon";
Vue.use(VueLuxon, {
  input: {
      zone: "local",
      format: "iso"
  },
  output: "relative"
});

require('worker-loader!pdfjs-dist/build/pdf.worker');

import VueMask from 'v-mask';
Vue.use(VueMask);

import { localize } from 'vee-validate';
import pt from "vee-validate/dist/locale/pt_BR.json";
localize('pt_BR', pt);

import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/popper.min.js';
import '@popperjs/core'; 
import 'jquery/dist/jquery';

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
